import context from '../config/context'

const { name, copyright } = context.branding

// Generic labels
export const OK = 'Ok'
export const NEXT = 'Next'
export const CANCEL = 'Cancel'
export const FINISH = 'Finish'
export const CONFIRM = 'Confirm'
export const EMAIL_PLACEHOLDER = 'email@company.com'
export const GENERIC_SERVER_ERROR =
  'Could not execute request. Please try again later'
export const NEED_HELP = 'Need help?'

// TalkdeskFooter
export const FOOTER_LICENSE = copyright
export const SUPPORT = 'Support'
export const TERMS_OF_SERVICE = 'Terms of Service'
export const PRIVACY_POLICY = 'Privacy Policy'
export const GOOGLE_API_SERVICES = 'Google API Services'

// TalkdeskNavbar
export const RETURN_TO_LOGIN = 'Return to login'
export const LOGO_ALTERNATE_TEXT = `${name} Logo`
export const PROCEED_TO_TALKDESK = `Proceed to ${name}`
export const LOGOUT = 'Logout'

// PasswordReset
export const PASSWORD_RESET_TITLE = 'Password reset'
export const PASSWORD_RESET_MESSAGE = `Enter the email you use for ${name} and we’ll send you instructions to reset your password`
export const PASSWORD_RESET_ERROR_MESSAGE =
  'Could not execute request. Please try again later'
export const EMAIL = 'Email'
export const EMAIL_VALIDATION_MESSAGE = 'The email format is incorrect'
export const REQUEST_PASSWORD_ACTION = 'Request password reset'

// CheckEmail
export const CHECK_EMAIL_TITLE = 'Check your email'
export const CHECK_EMAIL_MESSAGE =
  "We sent you instructions to reset your password, please check your spam folder as well. In case you can't find this email, contact Support."
// PasswordChange
export const PASSWORD_CHANGE_TITLE = 'Change password'
export const CURRENT_PASSWORD = 'Current password'
export const PASSWORD = 'New password'
export const PASSWORD_CONFIRMATION = 'Confirm new password'
export const PASSWORD_CHANGE_ACTION = 'Change password'
export const BREACHED_PASSWORD_MESSAGE =
  'Please choose a password that has not appeared in a known data breach'

// PasswordChange errors
export const DIFFERENT_PASSWORDS_ERROR_MESSAGE = "Passwords don't match"
export const GENERIC_PASSWORD_CHANGE_ERROR =
  'Unable to change your password. Please try again later'
export const INVALID_RESET_TOKEN_ERROR_PART_1 =
  'Unable to change your password. Request a new '
export const INVALID_RESET_TOKEN_ERROR_PART_2 = 'Password reset'
export const LOW_QUALITY_PASSWORD_ERROR_PART_1 =
  'Please choose a stronger password. '
export const CURRENT_PASSWORD_DOESNT_MATCH_MESSAGE =
  'The current password is not valid'

// AcceptInvitation
export const CONFIRM_ACCOUNT_TITLE = 'Confirm your account'

// AcceptInvitationForm
export const ACCEPT_INVITATION_FORM_NAME = 'Name'
export const ACCEPT_INVITATION_FORM_EMAIL = 'Email'
export const ACCEPT_INVITATION_ACTION = 'Confirm account'
export const GENERIC_INVITATION_ERROR =
  'Unable to validate your invitation. Please try again later'

// RecoveryOTPBox

// SetupMFAEnforced
export const SETUP_MFA_ENFORCED_TITLE = 'Two-factor authentication'
export const SETUP_MFA_ENFORCED_SUBTITLE =
  'This account has two-factor authentication enforced by your admin. To proceed with your login, setup an authentication method'
export const SETUP_MFA_ENFORCED_ACTION_MESSAGE = 'Setup'
export const SETUP_MFA_ENFORCED_GENERIC_ERROR =
  'Something went wrong. Please try again later'

// Show Password Policies
export const PASSWORD_POLICIES_TITLE = 'Your password must have:'
export const PASSWORD_POLICIES_LIST_CHARACTER = ' - '
export const PASSWORD_POLICIES_NUMBER_OF_CHARACTERS = (numberOfCharacters) =>
  `${numberOfCharacters} characters`
export const PASSWORD_POLICIES_NUMBER_OF_UPPER_CASE_CHARACTERS = (
  upperCaseCharacters,
) => `${upperCaseCharacters} upper case character(s)`
export const PASSWORD_POLICIES_NUMBER_OF_LOWER_CASE_CHARACTERS = (
  lowerCaseCharacters,
) => `${lowerCaseCharacters} lower case character(s)`
export const PASSWORD_POLICIES_MIN_NUMBERS_CHARACTERS = (
  minNumbersCharacters,
) => `${minNumbersCharacters} number(s)`
export const PASSWORD_POLICIES_NUMBER_OF_SPECIAL_CHARACTERS = (
  specialCharacters,
) =>
  `${specialCharacters} special character(s) !@#$%^&/(){}=?*+´\`'|"\\-_,;.:<> `
